import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create({
  modalRoot: {
    flex: 1
  },
  modelTitleCenter: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  successSection: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    bottom: 0
  },
  successText: {
    flex: 6,
    flexDirection: 'row',
    justifyContent: 'center'
  },
  successDesc: {
    color: PALETTE.grey,
    textAlign: 'center',
  },
  successButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20
  },
  errorText: {
    color: PALETTE.errorColor
  },
});
